import actions from './actions';
import mutations from './mutations';
import getters from './getters';
import { initialState } from './initialState';

const state = initialState();

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
